<div class="dashboard-container container-fluid px-0">
  <div class="row g-0 vh-100 overflow-hidden">
    <div
      v-if="!is_mobile"
      class="col-auto sidebar-wrapper d-flex flex-column flex-shrink-0 vh-100 overflow-hidden"
      :class="{ 'sidebar-collapsed': sidebar_collapsed }"
    >
      <MiningSidebar
        v-if="sidebar_sector === 'mining'"
        :active_item="sidebar_mining_item"
        :can_view_portfolio="sidebar_can_view_portfolio"
        @go-overview="open_sidebar_portfolio"
        @mining-menu-selected="open_sidebar_mining_menu"
        @select-sector="open_sidebar_sector"
      />
      <PropertySidebar
        v-else-if="sidebar_active_property"
        :active_property="sidebar_active_property"
        :properties="sidebar_tiles"
        :active_item="sidebar_active_item"
        :can_view_portfolio="sidebar_can_view_portfolio"
        @switch-property="open_sidebar_property"
        @go-back="open_sidebar_portfolio"
        @property-menu-selected="open_sidebar_property_menu"
        @select-sector="open_sidebar_sector"
      />
      <PortfolioSidebar
        v-else
        :tiles="sidebar_tiles"
        @tile-clicked="open_sidebar_property"
        @global-menu-selected="open_sidebar_portfolio"
        @property-menu-selected="open_sidebar_property_menu"
        @global-selected="open_sidebar_portfolio"
        @select-sector="open_sidebar_sector"
      />
    </div>

    <div v-if="is_mobile && mobile_sidebar_open" class="mobile-sidebar-overlay" @click.self="mobile_sidebar_open = false">
      <div class="mobile-sidebar-panel h-100 overflow-hidden">
        <MiningSidebar
          v-if="sidebar_sector === 'mining'"
          :active_item="sidebar_mining_item"
          :can_view_portfolio="sidebar_can_view_portfolio"
          @go-overview="open_sidebar_portfolio"
          @mining-menu-selected="open_sidebar_mining_menu"
          @select-sector="open_sidebar_sector"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center p-0" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </MiningSidebar>
        <PropertySidebar
          v-else-if="sidebar_active_property"
          :active_property="sidebar_active_property"
          :properties="sidebar_tiles"
          :active_item="sidebar_active_item"
          :can_view_portfolio="sidebar_can_view_portfolio"
          @switch-property="open_sidebar_property"
          @go-back="open_sidebar_portfolio"
          @property-menu-selected="open_sidebar_property_menu"
          @select-sector="open_sidebar_sector"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center p-0" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </PropertySidebar>
        <PortfolioSidebar
          v-else
          :tiles="sidebar_tiles"
          @tile-clicked="open_sidebar_property"
          @global-menu-selected="open_sidebar_portfolio"
          @property-menu-selected="open_sidebar_property_menu"
          @global-selected="open_sidebar_portfolio"
          @select-sector="open_sidebar_sector"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center p-0" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </PortfolioSidebar>
      </div>
    </div>

    <button v-if="!is_mobile" class="sidebar-collapse-btn btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center p-0" @click="sidebar_collapsed = !sidebar_collapsed" aria-label="Toggle sidebar">
      <i :class="sidebar_collapsed ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
    </button>

    <div class="col vh-100 d-flex flex-column overflow-hidden no-scrollbar">
    <HeaderSection 
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
        @open-assistant="showAssistant = true"
        @toggle-mobile-sidebar="toggle_mobile_sidebar"
    />

<div class="container-fluid p-0 profile-page flex-grow-1 min-h-0">

    <div v-if="show_error_snackbar && error" class="toast-container position-fixed bottom-0 end-0 p-3" aria-live="polite" aria-atomic="true">
        <div class="toast show align-items-center border-0 shadow-lg auth-toast auth-toast-error" role="alert">
            <div class="d-flex align-items-center gap-3 p-3">
                <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
                    <i class="bi bi-exclamation-circle"></i>
                </span>
                <div class="toast-body p-0 fw-semibold lh-sm">{{ error }}</div>
                <button type="button" class="btn-close ms-auto flex-shrink-0" aria-label="Dismiss error message" @click="clear_error"></button>
            </div>
        </div>
    </div>

    <!-- LOADING STATE -->
    <div v-if="loading" class="container text-center py-5">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2">Loading profile...</p>
    </div>

    <!-- ERROR STATE -->
    <div v-else-if="error" class="container py-5 text-center text-muted">
        Unable to load profile data.
    </div>

    <!-- PROFILE CONTENT -->
    <div v-else>

        <!-- TOP SECTION -->
        <section class="container py-4">
            <p class="aic-page-eyebrow text-uppercase fw-bold mb-2">Account overview</p>

            <!-- ROW: AVATAR + USER DETAILS + EDIT BUTTON -->
            <div class="row align-items-center aic-page-hero border rounded-4 p-4">

                <!-- Avatar -->
                <div class="col-md-2 text-center text-md-start mb-3 mb-md-0">
                    <div class="profile-avatar d-flex align-items-center justify-content-center mx-auto mx-md-0">
                        <span class="profile-avatar-text">{{ avatar_initials }}</span>
                    </div>
                </div>

                <!-- User details -->
                <div class="col-md-7 text-center text-md-start">
                    <h3 class="fw-bold mb-1">{{ fullName }}</h3>
                    <p class="text-muted mb-1">{{ userRole }} &bull; Member since {{ joinYear }}</p>
                </div>

                <!-- Edit button -->
                <div class="col-md-3 text-center text-md-end mt-3 mt-md-0">
                    <router-link
                        to="/edit_profile"
                        class="btn btn-danger btn-sm rounded-3 d-inline-flex align-items-center gap-1 px-3 shadow-sm text-decoration-none"
                    >
                        <i class="bi bi-pencil-square text-xs"></i>
                        <span class="text-xs">Edit Profile</span>
                    </router-link>

                </div>
            </div>
        </section>

        <!-- CONTENT SECTIONS -->
        <section class="container profile-sections">

            <div class="row g-4">

                <!-- CONTACT INFORMATION -->
                <div class="col-md-6">
                    <div class="glass-card p-4 rounded-4 h-100">
                        <h6 class="fw-semibold mb-3">Contact Information</h6>

                        <div class="d-flex align-items-center mb-3">
                            <div class="icon-box me-3">
                                <i class="bi bi-envelope-fill"></i>
                            </div>
                            <span class="text-muted">{{ userEmail }}</span>
                        </div>

                        <div class="d-flex align-items-center">
                            <div class="icon-box me-3">
                                <i class="bi bi-telephone-fill"></i>
                            </div>
                            <span class="text-muted">{{ userPhone }}</span>
                        </div>
                    </div>
                </div>

                <!-- PROFILE PROGRESS -->
                <div class="col-md-6">
                    <div class="glass-card p-4 rounded-4 h-100">
                        <div class="d-flex justify-content-between mb-2">
                            <h6 class="fw-semibold mb-0">Profile Progress</h6>
                            <span class="fw-bold fs-4">{{ profileProgress }}%</span>
                        </div>

                        <div class="progress rounded-3 mb-2 progress-lg">
                            <div 
                                class="progress-bar progress-bar-custom" 
                                :style="{ width: profileProgress + '%' }"
                            ></div>
                        </div>

                        <small class="text-muted">
                            Complete <strong>{{ remainingItems }}</strong> more item{{ remainingItems !== 1 ? 's' : '' }} to reach 100%
                        </small>
                    </div>
                </div>

            </div>

            <!-- COMPLETE YOUR PROFILE -->
            <div class="glass-card p-4 rounded-4 mt-4">

                <h6 class="fw-semibold mb-4">Complete Your Profile</h6>

                <div class="row g-3">

                    <!-- Email Verified -->
                    <div class="col-md-6">
                        <div class="completion-item p-3 rounded-3 d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center">
                                <i 
                                    class="bi me-2" 
                                    :class="isEmailVerified ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'"
                                ></i>
                                <span class="text-muted">
                                    {{ isEmailVerified ? 'Email Verified' : 'Verify Email' }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Phone Number -->
                    <div class="col-md-6">
                        <div class="completion-item p-3 rounded-3 d-flex align-items-center justify-content-between" :class="{ 'incomplete': !hasPhoneNumber }">
                            <div class="d-flex align-items-center">
                                <i 
                                    class="bi me-2" 
                                    :class="hasPhoneNumber ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'"
                                ></i>
                                <span class="text-muted">
                                    {{ hasPhoneNumber ? 'Phone Added' : 'Add Phone Number' }}
                                </span>
                            </div>
                            <i v-if="!hasPhoneNumber" class="bi bi-chevron-right text-muted"></i>
                        </div>
                    </div>

                    <!-- First Name -->
                    <div class="col-md-6">
                        <div class="completion-item p-3 rounded-3 d-flex align-items-center justify-content-between" :class="{ 'incomplete': !userProfile?.first_name }">
                            <div class="d-flex align-items-center">
                                <i 
                                    class="bi me-2" 
                                    :class="userProfile?.first_name ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'"
                                ></i>
                                <span class="text-muted">
                                    {{ userProfile?.first_name ? 'First Name Added' : 'Add First Name' }}
                                </span>
                            </div>
                            <i v-if="!userProfile?.first_name" class="bi bi-chevron-right text-muted"></i>
                        </div>
                    </div>

                    <!-- Last Name -->
                    <div class="col-md-6">
                        <div class="completion-item p-3 rounded-3 d-flex align-items-center justify-content-between" :class="{ 'incomplete': !userProfile?.last_name }">
                            <div class="d-flex align-items-center">
                                <i 
                                    class="bi me-2" 
                                    :class="userProfile?.last_name ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'"
                                ></i>
                                <span class="text-muted">
                                    {{ userProfile?.last_name ? 'Last Name Added' : 'Add Last Name' }}
                                </span>
                            </div>
                            <i v-if="!userProfile?.last_name" class="bi bi-chevron-right text-muted"></i>
                        </div>
                    </div>

                </div>

            </div>

        </section>
    </div>

    <!-- AIC Assistant -->
    <BolideAssistant :is_open="showAssistant" @close-assistant="showAssistant = false" />

</div>
    </div>
  </div>
</div>
